module.exports = __webpack_public_path__ + "img/icon-increase.f0fc5478.svg";